import React from "react";
import { Route } from "react-router-dom";
//
export default ({ component: C, appRef: cRef, ...rest }) =>
  <Route {...rest} render={props => <C {...props} {...cRef.childProps} app={cRef.props.app} alertController={cRef.props.alertController}/> } />;
